import { useMsal } from "@azure/msal-react";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { MenuOptionConfig } from "../MenuOptions";
import { MenuOption } from "./MenuOption";

const menuOption: MenuOptionConfig = {
  icon: <ExitToAppIcon />,
  textKey: "adminPanel.logout",
};

export const Logout = (props: LogoutProps) => {
  const { instance } = useMsal();

  const logout = () => {
    instance.logoutRedirect();
  };
  return (
    <div className="col-12 px-0">
      <MenuOption
        option={menuOption}
        currentPath="---"
        onClick={logout}
        isExpanded={props.isExpanded}
      />
    </div>
  );
};

interface LogoutProps {
  isExpanded: boolean;
}
